import { render, staticRenderFns } from "./DirectoryTable.vue?vue&type=template&id=affc8a34&scoped=true&"
import script from "./DirectoryTable.vue?vue&type=script&lang=js&"
export * from "./DirectoryTable.vue?vue&type=script&lang=js&"
import style0 from "./DirectoryTable.vue?vue&type=style&index=0&id=affc8a34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affc8a34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('affc8a34')) {
      api.createRecord('affc8a34', component.options)
    } else {
      api.reload('affc8a34', component.options)
    }
    module.hot.accept("./DirectoryTable.vue?vue&type=template&id=affc8a34&scoped=true&", function () {
      api.rerender('affc8a34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/directories/DirectoryTable.vue"
export default component.exports